import React from 'react';
import Credentials from './credentials';
import ResumeStyle from './ResumeStyle';
import ResumeSection from './ResumeSection';
import PdfLogo from '../assets/Adobe_PDF_file_icon_32x32.png';
import ResumePdf from '../assets/Roy_Watson--Resume.pdf'

class Resume extends React.Component {

    constructor(props) {
        super();

        this.state = {
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        };

        this.styler = new ResumeStyle();

        this.updateDimensions = this.updateDimensions.bind(this);

        var item = Credentials.data.sections[0].subsections[0].items[0];
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions(event) {
        this.styler.setWidth(document.documentElement.clientHeight);
        this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });
    }

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (
            <div>
                <div style={this.styler.currStyles.Download}>
                    <section style={this.styler.currStyles.Download.section}>
                        <p style={this.styler.currStyles.Download.text}>
                            <img alt="pdf" src={PdfLogo}/>
                            <a style={this.styler.currStyles.Download.text}
                               href={ResumePdf} download> Download pdf version
                            </a>
                        </p>
                    </section>
                </div>
                <div style={this.styler.currStyles.Container}>
                    {/*<p>{viewWidth}</p>*/}
                    <section style={this.styler.currStyles.Header.section}>
                        <p style={this.styler.currStyles.Header.name}>Roy Watson</p>
                        <p style={this.styler.currStyles.Header.address}>P.O. Box 3298</p>
                        <p style={this.styler.currStyles.Header.address}>Burlington, VT 05408</p>
                        <p style={this.styler.currStyles.Header.email}>rwatson@roywatson.com</p>
                        <p style={this.styler.currStyles.Header.phone}>+1 802.735.1500</p>
                    </section>
                    <section style={this.styler.currStyles.Body}>
                        <section style={this.styler.currStyles.Body.Introduction}>
                            <p style={this.styler.currStyles.Body.Introduction.title}>Introduction:</p>
                            <p style={this.styler.currStyles.Body.Introduction.text}>I have been a self-employed,
                                free-lance software and hardware developer for many years. I have a long history of
                                developing market ready systems within schedule and budget.</p>
                        </section>
                        {Credentials.data.sections.map((section) =>
                            <ResumeSection data={section} currStyles={this.styler.currStyles}/>
                        )}
                        <section style={this.styler.currStyles.Body.Section}>
                            <p style={this.styler.currStyles.Body.Section.title}>Education:</p>
                            <p style={this.styler.currStyles.Body.Section.school}>Purdue University</p>
                            <p style={this.styler.currStyles.Body.Section.schoolInfo}>Major: Physics.</p>
                            <p style={this.styler.currStyles.Body.Section.schoolInfo}>Minor: Aeronautical and
                                Astronautical Engineering.</p>
                            <p style={this.styler.currStyles.Body.Section.schoolInfo}>Work Study Job: Programming of
                                dual computers controlling a 100m Van de Graaff linear particle accelerator for
                                high-energy physics research.</p>
                            <br/>
                        </section>
                        <section style={this.styler.currStyles.Body.Section}>
                            <p style={this.styler.currStyles.Body.Section.title}>Other:</p>
                            <p style={this.styler.currStyles.Body.Section.schoolInfo}>Member of Mensa.</p>
                            <p style={this.styler.currStyles.Body.Section.schoolInfo}>FCC Licensed Amateur Radio
                                Operator.</p>
                        </section>
                    </section>
                </div>
            </div>
        );
    }
}

export default Resume


// WEBPACK FOOTER //
// src/ResumeAndDocs/Resume.js